import { useEffect, useState } from "react";
import api from "@/lib/api";

/**
 * Iteration 84 — checkpoint: coupon-visibility-toggles-and-contact-note.
 *
 * Fetches the admin-controlled visibility flags for the coupon input on
 * customer session/book pages. Defaults to BOTH visible so the current
 * customer experience is preserved when the endpoint is unreachable or
 * no setting has been saved yet.
 *
 * Purely a display switch — the underlying /coupons/validate API is
 * untouched, so turning a flag back ON restores the existing coupon
 * behavior immediately without any coupon record change.
 */
export default function useCouponVisibility() {
  const [visibility, setVisibility] = useState({ sessions: true, book: true });

  useEffect(() => {
    let alive = true;
    api
      .get("/coupon-visibility")
      .then(({ data }) => {
        if (!alive || !data) return;
        setVisibility({
          sessions: data.sessions !== false,
          book: data.book !== false,
        });
      })
      .catch(() => {
        // Silent — keep defaults (both visible).
      });
    return () => {
      alive = false;
    };
  }, []);

  return visibility;
}
